export default __webpack_public_path__ + "static/media/black.8c4986ee.svg";